import { forwardRef, useLayoutEffect, useRef } from "react";
import { Textarea } from "@/components/ui/textarea";

export const AutoTextarea = forwardRef(({ value, className = "", maxVh = 70, ...props }, _ref) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight + 2, (window.innerHeight * maxVh) / 100)}px`;
  }, [value, maxVh]);
  return <Textarea ref={ref} value={value} className={`resize-y overflow-y-auto lf-scroll ${className}`} {...props} />;
});
AutoTextarea.displayName = "AutoTextarea";
